<template>
<v-card>
    <v-card-title class="headline">Crop Row</v-card-title>
    <v-card-text>
        <v-form ref="editForm" v-model="formValid">
            <v-layout class="dialog-content">
                <v-flex xs12>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-text-field box clearable label="Row Name" v-model="editData.RowNumber" :rules="[
                                    rules.required, 
                                    rules.maxfiftyCharacters
                                ]" counter>
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-autocomplete label="Variety" :items="ProductVarieties" item-value="ProductVarietyID" item-text="Name" v-model="editData.ProductVarietyID" :rules="[rules.requiredObject]" box clearable placeholder="Select Variety">
                            </v-autocomplete>
                        </v-flex>
                        <v-flex xs12>
                            <v-menu v-model="plantingMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field :value="formatDate(editData.PlantingDate)" label="Planting Date" prepend-icon="event" readonly v-on="on" append-icon="close" @click:append="clearPlantingDate"></v-text-field>
                                </template>
                                <v-date-picker :value="formatDateYMD(editData.PlantingDate)" @input="updatePlantingDate"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field box clearable label="Number of Bushes" v-model="editData.NumberOfBushes" :rules="[
                                    rules.required, 
                                    integer
                                ]" 
                                type="number"
                                counter>
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field box clearable label="Area (ha)" v-model="editData.AreaHA" :rules="[
                                    rules.required, 
                                    decimal
                                ]" 
                                type="number"
                                counter>
                            </v-text-field>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-form>
        <v-alert :value="submitError != null" outline type="error">
            <span>{{ submitError }}</span>
        </v-alert>
    </v-card-text>
    <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" :disabled="!formValid" @click="submit">OK</v-btn>
        <v-btn color="error" @click="cancel">Cancel</v-btn>
    </v-card-actions>
</v-card>
</template>

<script>
import validationRules from "@/helpers/validationrules";
import UtilService from '@/services/utilService.js';

export default {
    props: {
        productTypeID: {
            required: true,
            type: Number
        },
        item: {
            required: true,
            type: Object
        },
        submitError: {
            required: false,
            type: String
        },
    },
    data() {
        return {
            plantingMenu: false,
            rules: validationRules.rules,
            editData: {},
            formValid: false            
        }
    },
    computed: {
        ProductVarieties() {
            return this.$store.getters["CropStore/getProductVarieties"](this.productTypeID)
        }
    },
    methods: {
        clearPlantingDate() {
            this.plantingMenu = true;
            this.$set(this.editData, 'PlantingDate', null);
            this.plantingMenu = false;
        },
        updatePlantingDate(v) {
            this.$set(this.editData, 'PlantingDate', v);
            this.plantingMenu = false;
        },
        integer(v){
            if(v == null || !v.match(/^[0-9]{1,15}$/)){
                return "Please enter a whole positive number";
            }

            return false;
        },
        decimal(v){
            if(v == null || !v.match(/^[0-9]{1,15}.?[0-9]{0,2}$/)){
                return "Please enter a number in the format of XXXXX.XX";
            }

            return false;
        },
        formatDate(v) {
            if (v) {
                return UtilService.formatDateDMY(v, '/');
            }

            return null;
        },
        formatDateYMD(v) {
            if(v) {
                return UtilService.formatDateYMD(v);
            } 
            return null;
        },
        cancel() {
            this.$emit("cancel");
        },
        submit() {
            this.editData.AreaSQM = parseFloat(this.editData.AreaHA || 0) * 10000;
            this.$emit("submit", this.editData);
        },
    },
    async created() {
        this.editData = JSON.parse(JSON.stringify(this.item));
        
        if (this.editData.AreaSQM) {        
            this.editData.AreaHA = (this.editData.AreaSQM / 10000).toFixed(2);
        }
    }
}
</script>
